<div class="ng-container">
    <form>
        <wd-text-input [(model)]="model.aText" name="aText" label="Ein Text (nur nicht &bdquo;Micha&ldquo;, Eine Zahl ist nicht so gut, aber &bdquo;Robert&ldquo; wäre perfekt)"></wd-text-input>
        <wd-text-input [(model)]="model.aDependentText" name="aDependentText" label="Irgendwas Neues. Aber bitte nicht gar nichts."></wd-text-input>
        <wd-number-input [(model)]="model.aFloat" name="aFloat" label="Eine Zahl"></wd-number-input>
        <wd-number-input [(model)]="model.aNumber" name="aNumber" label="Eine Ganzzahl (begrenzt, nicht-leer)" nonEmpty integer min="0" max="10"></wd-number-input>
        <wd-typeahead [(model)]="model.aListText" name="aListText" label="Ein Element aus einer Liste" from="hardCoded" tableName="Bodenvegetationen" placement="bottom"></wd-typeahead>
        <wd-typeahead [(model)]="model.aDfListText" name="aListDfText" label="Ein Element aus einer Dietmar-Liste" from="dietmarsMdb" tableName="zac_StFB_FA" tableColumn="Name" placement="bottom"></wd-typeahead>
        <wd-list-input [(model)]="model.aListOption" name="aListOption" label="Ein Element aus einer freien Liste als Option" options="1|2|3|4|5" prefix="st"></wd-list-input>
    </form>

    <div *ngIf="!vs.empty()">
        <p>Liste der aufgetretenen Fehler: </p>
        <ol>
            <li *ngFor="let e of vs.danger_ | keyvalue">{{e.key}}: {{e.value}}</li>
        </ol>
    </div>

    <p>aText: <wd-text [(model)]="model.aText" name="aText"></wd-text></p>
    <p>aDependentText: <wd-text [(model)]="model.aDependentText" name="aDependentText"></wd-text></p>
    <p>aFloat: <wd-number [(model)]="model.aFloat"></wd-number></p>
    <p>aNumber (min:max): <wd-number [(model)]="model.aNumber" nonEmpty integer min="0" max="10"></wd-number></p>
    <p>aListText: {{model.aListText}}</p>
    <p>aListOption: <wd-list [(model)]="model.aListOption" name="aListOption" options="1|2|3|4|5" prefix="st"></wd-list></p>
</div>
